import React, { useState, useEffect } from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import SearchInput from 'components/SearchInput'
import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ScrollBar } from 'components/CommonStyles'
import { Skeleton } from 'antd'

const Wrapper = styled.div`
  padding: 1rem 0.5rem;
`
const SectorFilter = ({

    sectorFilter,
    setSectorFilter,
  filterList,
  setFilterList,
  filterMaster

}) => {
  const [searchValue, setSearchValue] = useState('')
   
    
  const [pageNum, setPageNum] = useState(1)


  const onChange = checkedvalue => {
    if (searchValue) {
      // When searching, merge new selections with existing ones
      const existingSelections = sectorFilter?.filter(item => 
        !filterList?.some(listItem => listItem.label === item)
      ) || [];
      setSectorFilter([...existingSelections, ...checkedvalue]);
    } else {
      setSectorFilter(checkedvalue);
    }
  }


useEffect(() => {
  if(searchValue != '')
  {
  const results = filterMaster?.filter(item =>
    item?.label?.toLowerCase()?.includes(searchValue)
  );
  setFilterList(results);
}
else{
  setFilterList(filterMaster)
}
},[searchValue, sectorFilter, filterMaster])
  return (
    <Wrapper>
      <SearchInput
        width={'90%'}
        placeholder="Search by keyword"
        bordered={true}
        setSearchValue={setSearchValue}
        
      />

<ScrollBar id="scrollableDiv" height={'28vh'}>

          <FilterCheckBoxComp
            padding="8px 10px !important"
            options={filterList}
            value={sectorFilter}
            onChange={onChange}
            labelParam="label"
            valueParam="label"
          />
    </ScrollBar>
    </Wrapper>
  )
}

export default SectorFilter